// Version : 0.0.1
// Author : AGALYA

const progressReportTypes = {
	/************** GET PROGRESS REPORT START **************************** */
	GET_PROGRESS_REPORT_START: 'get_progress_report_start',
	GET_PROGRESS_REPORT_SUCCESS: 'get_progress_report_success',
	GET_PROGRESS_REPORT_FAILURE: 'get_progress_report_failure',
	GET_PROGRESS_REPORT_CHANGED: 'get_progress_report_changed',
	GET_PROGRESS_REPORT_RESPONSE_CHANGED: 'get_progress_report_response_changed',
	GET_PROGRESS_REPORT_RESET: 'get_progress_report_reset',
	/************** GET PROGRESS REPORT END **************************** */
};
export default progressReportTypes;
